import { Route } from 'types/route.type';
import { routes as welfareScoring } from './features/welfare-scoring/routes';

export const routes: Route[] = [...welfareScoring];
